export const hasOwnProperty = (thisArg: unknown, key: PropertyKey) =>
  Object.prototype.hasOwnProperty.call(thisArg, key);

type Dict = Record<string, unknown>;

/**
 * Sourced from MIT Licensed "fbjs"
 * https://raw.githubusercontent.com/facebook/fbjs/main/packages/fbjs/src/core/shallowEqual.js
 */
export const shallowEqual = <A = unknown, B = unknown>(
  objA: A,
  objB: B
): boolean => {
  if (Object.is(objA, objB)) {
    return true;
  }

  if (
    typeof objA !== 'object' ||
    objA === null ||
    typeof objB !== 'object' ||
    objB === null
  ) {
    return false;
  }

  const keysA = Object.keys(objA);
  const keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  return keysA.every(
    key =>
      hasOwnProperty(objB, key) &&
      Object.is((objA as Dict)[key], (objB as Dict)[key])
  );
};

export const filterOutEmptyObjectsOnObject = <
  T extends Record<string, unknown>,
>(
  object: Record<string, T>
) =>
  Object.fromEntries(
    Object.entries(object).filter(([, value]) => Object.keys(value).length > 0)
  );
